// @flow

import React from 'react';
import AvatarHoverCardAvatar from 'app/common/react/components/AvatarHoverCard/AvatarHoverCardAvatar';
import AvatarHoverCardContentText from 'app/common/react/components/AvatarHoverCard/AvatarHoverCardContentText';
import AvatarHoverCardFollowButton from 'app/common/react/components/AvatarHoverCard/AvatarHoverCardFollowButton';
import { Box } from 'gestalt';

type Props = {|
  avatarUrl: string,
  description: string,
  domainUrl: ?string,
  followerCount: number,
  isCreator: ?boolean,
  id: string,
  isHorizontalDesign: boolean,
  isVerified: boolean,
  userFullName: string,
  username: string,
  viewParameter?: $Values<PCONST.thrift.ViewParameterType>,
  viewType?: $Values<PCONST.thrift.ViewType>,
|};

function getProfileUrl(username: string) {
  return `/${username}`;
}

export default function AvatarHoverCardContent({
  avatarUrl,
  description,
  domainUrl,
  followerCount,
  id,
  isCreator,
  isHorizontalDesign,
  isVerified,
  userFullName,
  username,
  viewParameter,
  viewType,
}: Props) {
  const url = getProfileUrl(username);

  return (
    <Box
      alignItems={isHorizontalDesign ? 'start' : 'center'}
      display="flex"
      direction="column"
      paddingX={isHorizontalDesign ? 5 : 6}
      paddingY={isHorizontalDesign ? 3 : 4}
      marginTop={2}
      width="100%"
    >
      <AvatarHoverCardAvatar
        avatarUrl={avatarUrl}
        isHorizontalDesign={isHorizontalDesign}
        isVerified={isVerified}
        url={url}
        userFullName={userFullName}
        viewType={viewType}
        viewParameter={viewParameter}
      />
      {isHorizontalDesign && (
        <Box position="relative" width="100%">
          <Box display="flex" marginTop={-2} marginRight={-2} position="absolute" right top>
            <AvatarHoverCardFollowButton
              fullName={userFullName}
              followerCount={followerCount}
              id={id}
              imageUrl={avatarUrl}
              isHorizontalDesign={isHorizontalDesign}
              profileUrl={url}
              showFollowerCount={isCreator}
            />
          </Box>
          <Box width="100%" display="flex" left marginTop={1}>
            <AvatarHoverCardContentText
              description={description}
              domainUrl={domainUrl}
              isHorizontalDesign={isHorizontalDesign}
              userFullName={userFullName}
            />
          </Box>
        </Box>
      )}
      {!isHorizontalDesign && (
        <Box width="100%">
          <AvatarHoverCardContentText
            userFullName={userFullName}
            domainUrl={domainUrl}
            description={description}
            isHorizontalDesign={isHorizontalDesign}
          />
          <Box width="100%" display="flex" alignItems="center" justifyContent="center">
            <AvatarHoverCardFollowButton
              followerCount={followerCount}
              fullName={userFullName}
              id={id}
              imageUrl={avatarUrl}
              isHorizontalDesign={isHorizontalDesign}
              profileUrl={url}
              showFollowerCount={isCreator}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
